import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-16 bg-beige" data-id="element-44">
      <div className="max-w-3xl mx-auto px-6 text-center" data-id="element-45">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="flex flex-col items-center" data-id="element-46">
          <ShieldCheck size={40} className="text-olive mb-4" strokeWidth={1.5} data-id="element-47" />
          <p className="text-lg text-brown/80 font-light" data-id="element-48">
            Tu satisfacción es importante. Si sientes que este método no es para
            ti, puedes solicitar un reembolso completo dentro de los primeros 7
            días. Sin preguntas.
          </p>
        </motion.div>
      </div>
    </section>;
}